var map = {
	"./TNT/+x.png": 6732,
	"./TNT/+y.png": 8357,
	"./TNT/+z.png": 1630,
	"./TNT/-x.png": 7946,
	"./TNT/-y.png": 3155,
	"./TNT/-z.png": 7400,
	"./andesite.png": 8353,
	"./arrow-block-black.png": 247,
	"./arrow-block-blue.png": 6868,
	"./arrow-block-brown.png": 998,
	"./arrow-block-cyan.png": 9757,
	"./arrow-block-gray.png": 8253,
	"./arrow-block-green.png": 6471,
	"./arrow-block-light-blue.png": 4401,
	"./arrow-block-light-gray.png": 1140,
	"./arrow-block-lime.png": 3431,
	"./arrow-block-magenta.png": 331,
	"./arrow-block-orange.png": 5714,
	"./arrow-block-pink.png": 6676,
	"./arrow-block-purple.png": 7710,
	"./arrow-block-red.png": 9799,
	"./arrow-block-white.png": 705,
	"./arrow-block-yellow.png": 9392,
	"./azalea-flowering-leaves.png": 8103,
	"./azalea-leaves.png": 9083,
	"./birch-leaves.png": 8991,
	"./birch-log/+x.png": 8383,
	"./birch-log/+y.png": 4582,
	"./birch-log/+z.png": 6349,
	"./birch-log/-x.png": 1709,
	"./birch-log/-y.png": 8676,
	"./birch-log/-z.png": 9519,
	"./birch-planks-vine.png": 1319,
	"./birch-planks.png": 9672,
	"./black-concrete.png": 5871,
	"./blue-concrete.png": 4598,
	"./bookshelf-birch/+x.png": 1934,
	"./bookshelf-birch/+y.png": 9623,
	"./bookshelf-birch/+z.png": 1148,
	"./bookshelf-birch/-x.png": 4328,
	"./bookshelf-birch/-y.png": 2721,
	"./bookshelf-birch/-z.png": 6474,
	"./bookshelf-oak/+x.png": 3353,
	"./bookshelf-oak/+y.png": 3456,
	"./bookshelf-oak/+z.png": 7275,
	"./bookshelf-oak/-x.png": 4451,
	"./bookshelf-oak/-y.png": 2874,
	"./bookshelf-oak/-z.png": 7537,
	"./bookshelf-spruce/+x.png": 5764,
	"./bookshelf-spruce/+y.png": 9661,
	"./bookshelf-spruce/+z.png": 5686,
	"./bookshelf-spruce/-x.png": 1378,
	"./bookshelf-spruce/-y.png": 5035,
	"./bookshelf-spruce/-z.png": 9632,
	"./bricks-black.png": 1616,
	"./bricks-blue.png": 7441,
	"./bricks-brown.png": 6269,
	"./bricks-cyan.png": 8188,
	"./bricks-gray.png": 2308,
	"./bricks-green.png": 3576,
	"./bricks-light-blue.png": 7780,
	"./bricks-light-gray.png": 3229,
	"./bricks-lime.png": 8710,
	"./bricks-magenta.png": 7136,
	"./bricks-orange.png": 67,
	"./bricks-pink.png": 8453,
	"./bricks-purple.png": 6063,
	"./bricks-red.png": 3220,
	"./bricks-white.png": 7450,
	"./bricks-yellow.png": 7009,
	"./bricks.png": 2982,
	"./brown-concrete.png": 4896,
	"./brown-mushroom-block.png": 807,
	"./cherry-leaves.png": 8214,
	"./coal-block.png": 5665,
	"./coal-ore.png": 7454,
	"./cobbled-deepslate.png": 2473,
	"./cobblestone-snow/+x.png": 774,
	"./cobblestone-snow/+y.png": 7711,
	"./cobblestone-snow/+z.png": 852,
	"./cobblestone-snow/-x.png": 9472,
	"./cobblestone-snow/-y.png": 4297,
	"./cobblestone-snow/-z.png": 3586,
	"./cobblestone.png": 7340,
	"./cyan-concrete.png": 2349,
	"./dark-oak-leaves.png": 6003,
	"./deepslate-coal-ore.png": 9712,
	"./deepslate-diamond-ore.png": 7567,
	"./deepslate-emerald-ore.png": 6875,
	"./deepslate-gold-ore.png": 7359,
	"./deepslate-iron-ore.png": 7539,
	"./deepslate-ruby-ore.png": 3209,
	"./deepslate-sapphire-ore.png": 719,
	"./deepslate.png": 7983,
	"./diamond-block.png": 918,
	"./diamond-ore.png": 9822,
	"./diorite.png": 6468,
	"./dirt-arcade.png": 3086,
	"./dirt.png": 4615,
	"./emerald-block.png": 2094,
	"./emerald-ore.png": 9289,
	"./error.png": 5508,
	"./farmland-moist/+x.png": 196,
	"./farmland-moist/+y.png": 6877,
	"./farmland-moist/+z.png": 5670,
	"./farmland-moist/-x.png": 8514,
	"./farmland-moist/-y.png": 7515,
	"./farmland-moist/-z.png": 2480,
	"./farmland/+x.png": 5269,
	"./farmland/+y.png": 6172,
	"./farmland/+z.png": 6231,
	"./farmland/-x.png": 919,
	"./farmland/-y.png": 7902,
	"./farmland/-z.png": 9701,
	"./glass-aqua.png": 6961,
	"./glass-black.png": 2912,
	"./glass-blue.png": 4065,
	"./glass-brown.png": 6941,
	"./glass-dark-gray.png": 4181,
	"./glass-green.png": 7336,
	"./glass-light-blue.png": 1588,
	"./glass-light-gray.png": 9597,
	"./glass-lime.png": 598,
	"./glass-magenta.png": 1184,
	"./glass-orange.png": 6515,
	"./glass-pink.png": 8661,
	"./glass-purple.png": 2895,
	"./glass-red.png": 2116,
	"./glass-white.png": 8346,
	"./glass-yellow.png": 5233,
	"./glass.png": 2566,
	"./gold-block.png": 3162,
	"./gold-ore.png": 3029,
	"./granite.png": 7964,
	"./grass-arcade.png": 3783,
	"./grass-block-pine/+x.png": 7675,
	"./grass-block-pine/+y.png": 4018,
	"./grass-block-pine/+z.png": 8025,
	"./grass-block-pine/-x.png": 5505,
	"./grass-block-pine/-y.png": 4376,
	"./grass-block-pine/-z.png": 131,
	"./grass-block/+x.png": 2916,
	"./grass-block/+y.png": 4045,
	"./grass-block/+z.png": 2838,
	"./grass-block/-x.png": 5682,
	"./grass-block/-y.png": 507,
	"./grass-block/-z.png": 2176,
	"./grass-flower-block-pine/+x.png": 8953,
	"./grass-flower-block-pine/+y.png": 7776,
	"./grass-flower-block-pine/+z.png": 6107,
	"./grass-flower-block-pine/-x.png": 7235,
	"./grass-flower-block-pine/-y.png": 2026,
	"./grass-flower-block-pine/-z.png": 2609,
	"./grass-flower-block/+x.png": 746,
	"./grass-flower-block/+y.png": 8323,
	"./grass-flower-block/+z.png": 3048,
	"./grass-flower-block/-x.png": 8620,
	"./grass-flower-block/-y.png": 8037,
	"./grass-flower-block/-z.png": 9886,
	"./grass-flower-pine.png": 6975,
	"./grass-flower.png": 3146,
	"./grass-pine.png": 7741,
	"./grass-snow-block/+x.png": 5966,
	"./grass-snow-block/+y.png": 5191,
	"./grass-snow-block/+z.png": 7084,
	"./grass-snow-block/-x.png": 4664,
	"./grass-snow-block/-y.png": 7377,
	"./grass-snow-block/-z.png": 8394,
	"./grass.png": 9504,
	"./gray-concrete.png": 4941,
	"./green-concrete.png": 5959,
	"./grid-copper.png": 1500,
	"./grid-gold.png": 5769,
	"./grid-iron.png": 7369,
	"./hay-block/+x.png": 1568,
	"./hay-block/+y.png": 6393,
	"./hay-block/+z.png": 1250,
	"./hay-block/-x.png": 2870,
	"./hay-block/-y.png": 2847,
	"./hay-block/-z.png": 4548,
	"./honeycomb-big.png": 3537,
	"./honeycomb-small.png": 5286,
	"./ice.png": 7335,
	"./iron-block.png": 6258,
	"./iron-ore.png": 2138,
	"./jungle-leaves.png": 946,
	"./lava-stone.png": 6778,
	"./lava.png": 6918,
	"./light-blue-concrete.png": 9081,
	"./light-gray-concrete.png": 8166,
	"./lime-concrete.png": 8311,
	"./magenta-concrete.png": 4619,
	"./magma-block.png": 7453,
	"./mesh-copper.png": 4661,
	"./mesh-gold.png": 9764,
	"./mesh-iron.png": 4992,
	"./mossy-cobblestone.png": 112,
	"./mossy-stone-bricks.png": 866,
	"./mushroom-block.png": 6566,
	"./mushroom-stem.png": 9590,
	"./oak-leaves.png": 9284,
	"./oak-log/+x.png": 5692,
	"./oak-log/+y.png": 8581,
	"./oak-log/+z.png": 4574,
	"./oak-log/-x.png": 7642,
	"./oak-log/-y.png": 9219,
	"./oak-log/-z.png": 6008,
	"./oak-planks-vine.png": 2890,
	"./oak-planks.png": 4247,
	"./orange-concrete.png": 8564,
	"./pink-concrete.png": 198,
	"./purple-concrete.png": 7632,
	"./red-concrete.png": 6535,
	"./red-mushroom-block.png": 8884,
	"./ruby-block.png": 1284,
	"./ruby-ore.png": 9711,
	"./sand-wet.png": 1093,
	"./sand.png": 9182,
	"./sandstone/+x.png": 1693,
	"./sandstone/+y.png": 1748,
	"./sandstone/+z.png": 6399,
	"./sandstone/-x.png": 6303,
	"./sandstone/-y.png": 7286,
	"./sandstone/-z.png": 8525,
	"./sapphire-block.png": 8658,
	"./sapphire-ore.png": 6189,
	"./slime.png": 1078,
	"./smooth-stone.png": 7446,
	"./snow-rocky.png": 6906,
	"./snow.png": 5793,
	"./spruce-leaves.png": 7657,
	"./spruce-log/+x.png": 9889,
	"./spruce-log/+y.png": 8760,
	"./spruce-log/+z.png": 4371,
	"./spruce-log/-x.png": 2683,
	"./spruce-log/-y.png": 1554,
	"./spruce-log/-z.png": 9737,
	"./spruce-planks-vine.png": 5521,
	"./spruce-planks.png": 4006,
	"./stone-bricks.png": 150,
	"./stone.png": 4921,
	"./water.png": 3191,
	"./white-concrete.png": 6209,
	"./wool-black.png": 3037,
	"./wool-blue.png": 206,
	"./wool-brown.png": 6860,
	"./wool-cyan.png": 51,
	"./wool-dark-gray.png": 8416,
	"./wool-green.png": 6253,
	"./wool-light-blue.png": 2927,
	"./wool-light-gray.png": 1798,
	"./wool-lime.png": 157,
	"./wool-magenta.png": 2685,
	"./wool-orange.png": 7011,
	"./wool-pink.png": 4778,
	"./wool-purple.png": 9248,
	"./wool-red.png": 509,
	"./wool-white.png": 3063,
	"./wool-yellow.png": 7726,
	"./yellow-concrete.png": 4090
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5277;